





































import Vue from 'vue'
import { sprintf } from 'sprintf-js'
import { getText } from '../js/lang'
import { countHalfwidth } from '../js/string'

const NAME_CHAR_LIMIT = 32
const OUTGOING_CHAR_LIMIT = 64
const MISSION_CHAR_LIMIT = 256

interface Validation {
  name?: string
  outgoing_message?: string
  mission_message?: string
}

export default Vue.extend({
  name: 'stamp-editor',
  props: {
    lang: {
      type: String,
      required: true
    },
    ticketId: {
      type: String,
      default: ''
    },
    outgoingMessage: {
      type: String,
      default: ''
    },
    missionMessage: {
      type: String,
      default: ''
    },
    confirmPublishing: {
      type: Boolean,
      default: false
    },
    validation: {
      type: Object as () => Validation,
      default: () => ({})
    }
  },
  data() {
    return {
      NAME_CHAR_LIMIT,
      OUTGOING_CHAR_LIMIT,
      MISSION_CHAR_LIMIT,
      localTicketId: this.ticketId,
      localOutgoingMessage: this.outgoingMessage,
      localMissionMessage: this.missionMessage,
      localConfirmPublishing: this.confirmPublishing
    }
  },
  computed: {
    nameCounter(): number {
      return 0
    },
    outgoingMessageCounter(): number {
      return countHalfwidth(this.localOutgoingMessage)
    },
    missionMessageCounter(): number {
      return countHalfwidth(this.localMissionMessage)
    }
  },
  watch: {
    localTicketId(val) {
      this.$emit('update:ticketId', val)
    },
    localOutgoingMessage(val) {
      this.$emit('update:outgoingMessage', val)
    },
    localMissionMessage(val) {
      this.$emit('update:missionMessage', val)
    },
    localConfirmPublishing(val) {
      this.$emit('update:confirmPublishing', val)
    }
  },
  methods: {
    l(key: string, ...values: any[]): string {
      return sprintf(getText(this.lang, key), ...values)
    },
    handleConfirm() {
      this.$emit('confirm', {
        ticketId: this.localTicketId,
        outgoingMessage: this.localOutgoingMessage,
        missionMessage: this.localMissionMessage,
        confirmPublishing: this.localConfirmPublishing
      })
    }
  }
})
